export const NewUpdateBlogConfig = {
    "dev": {
        en: 11583452,
        de: 11583452,
        fr: 11583452
    },
    "staging":{
        en: 11531274,
        de: 11531277,
        fr: 11531280
    },
    "production":{
        en: 11583452,
        de: 11583470,
        fr: 11583473
    },
}